export default __webpack_public_path__ + "static/media/digistore24.alt.d57397f6.png";